import { formatOfferListPrice } from "../../../../../../../../../../utilities/helpers";

export default function PriceTooltip({ target }) {
  return (
    <div className="purchaseTooltip">
      <p>From: {formatOfferListPrice(target?.price, target?.offer)}</p>
    </div>
  );
}
